module.exports = __webpack_public_path__ + "img/metrics-icon-active.6115d4ba.svg";